
export const TOP_RANKING_INDEX_REQUEST = 'TOP_RANKING_INDEX_REQUEST';
export const TOP_RANKING_INDEX_SUCCESS = 'TOP_RANKING_INDEX_SUCCESS';
export const TOP_RANKING_INDEX_ERROR = 'TOP_RANKING_INDEX_ERROR';

export const TOP_RANKING_DETAIL_REQUEST = 'TOP_RANKING_DETAIL_REQUEST';
export const TOP_RANKING_DETAIL_SUCCESS = 'TOP_RANKING_DETAIL_SUCCESS';
export const TOP_RANKING_DETAIL_ERROR = 'TOP_RANKING_DETAIL_ERROR';
